export default __webpack_public_path__ + "111865e334577309eb55ee0322dfbacc.svg";